import React from 'react';
import { connect } from 'react-redux';

import { isRating } from 'src/store/hotelRating/selectors';
import {
  getHasReviewsSection,
  getHotelReviewsLink,
} from 'src/store/reviews/selectors';
import { getLinkedHotels } from 'src/routes/Hotel/store/hotel';
import { getIsWhitelabel } from '../../../../store/selectors/view';

import { ReviewsDesktop } from '..';
import { getSearchParamsForUrl } from '../../../../store/selectors/searchParams';

const mapStateToProps = (state) => ({
  isRatingExists: isRating(state),
  linkedHotels: getLinkedHotels(state),
  hasReviewsSection: getHasReviewsSection(state),
  searchParams: getSearchParamsForUrl(state),
  isWhitelabel: getIsWhitelabel(state),
  hotelReviewsLink: getHotelReviewsLink(state),
});

export default connect(mapStateToProps)(React.memo(ReviewsDesktop));
